module.exports = __webpack_public_path__ + "img/lg_ring_g_s_1_1.074c796d.png";